import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import CryptoJS from "crypto-js";
import { toast } from "react-hot-toast";
import "react-datepicker/dist/react-datepicker.css";

import "../../css/Rightforyou.css";

/* IMAGES */
import testops from "../../../assets/why-testops/testops.png";
import organization from "../../../assets/why-testops/organization.svg";

const initialData = {
  projectname: "",
  Projectshortcode: "",
  projectStatus: "",
  ProjectType: "",
  projectEffect: "",
  teamSize: "",
  Description: "",
};

function Rightforyou({ getTestOps: initialGetTestOps, setGetTestOps }) {
  const [getTestOps, setLocalGetTestOps] = useState(initialGetTestOps || false);

  const sectionRef = useRef(null);
  const sectionReftwo = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [startDate, setStartDate] = useState(null);
  const [EndDate, setEndDate] = useState(null);

  const projectNameRef = useRef(null);
  const projectShortCodeRef = useRef(null);
  const projectStatusRef = useRef(null);
  const projectTypeRef = useRef(null);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const projectEffectRef = useRef(null);
  const teamSizeRef = useRef(null);
  const descriptionRef = useRef(null);

  const secretKey = "FrosttestopsSecretKey";

  const [formData, setFormData] = useState(() => {
    const stored = localStorage.getItem("projectForm");

    if (stored) {
      try {
        const bytes = CryptoJS.AES.decrypt(stored, secretKey);

        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      } catch {
        localStorage.removeItem("projectForm");
      }
    }

    return initialData;
  });

  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(formData),
      secretKey
    ).toString();

    localStorage.setItem("projectForm", encrypted);
  }, [formData]);

  useEffect(() => {
    const clicked = params.get("clicked");
    const hash = window.location.hash;

    if ((clicked === "true" || hash === "#priceform") && sectionRef.current) {

      const rect = sectionRef.current.getBoundingClientRect();

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      window.scrollTo({
        top: rect.top + scrollTop - 100,
        behavior: "smooth",
      });
    }
  }, [location.search]);

  const validateForm = () => {

    const errors = {};

    if (!formData.projectname.trim()) {
      errors.projectname = "Project name is required.";
    }

    if (!formData.Projectshortcode.trim()) {
      errors.Projectshortcode = "Short code is required.";
    } else if (!/^[A-Za-z]{2,5}$/.test(formData.Projectshortcode)) {
      errors.Projectshortcode = "2 to 5 letters only.";
    }

    if (!formData.projectStatus) {
      errors.projectStatus = "Project status is required.";
    }

    if (!formData.ProjectType) {
      errors.ProjectType = "Project type is required.";
    }

    if (!startDate) {
      errors.startDate = "Start date required";
    }

    if (!EndDate) {
      errors.EndDate = "End date required";
    }

    if (startDate && EndDate && EndDate < startDate) {
      errors.EndDate = "End date invalid";
    }

    if (!formData.projectEffect) {
      errors.projectEffect = "Planned effort required";
    }

    if (!formData.teamSize) {
      errors.teamSize = "Team size required";
    }

    if (!formData.Description) {
      errors.Description = "Description required";
    }

    return errors;
  };

  const scrollToFirstError = useCallback(() => {

    const refs = [
      [formErrors.projectname, projectNameRef],
      [formErrors.Projectshortcode, projectShortCodeRef],
      [formErrors.projectStatus, projectStatusRef],
      [formErrors.ProjectType, projectTypeRef],
      [formErrors.startDate, startDateRef],
      [formErrors.EndDate, endDateRef],
      [formErrors.projectEffect, projectEffectRef],
      [formErrors.teamSize, teamSizeRef],
      [formErrors.Description, descriptionRef],
    ];

    for (let [err, ref] of refs) {
      if (err && ref.current) {
        ref.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        break;
      }
    }

  }, [formErrors]);

  useEffect(() => {
    if (Object.keys(formErrors).length) {
      scrollToFirstError();
    }
  }, [formErrors, scrollToFirstError]);

  const ProjectForFree = () => {

    const errors = validateForm();

    if (Object.keys(errors).length) {
      setFormErrors(errors);
      return;
    }

    const fullData = {
      ...formData,
      startDate: startDate?.toISOString(),
      EndDate: EndDate?.toISOString(),
    };

    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(fullData),
      secretKey
    ).toString();

    localStorage.setItem("projectForm", encrypted);

    toast.success(
      "Kindly fill the form to proceed with creating the new project",
      {
        duration: 4000,
      }
    );

    navigate("/freemium?isAdUser=true");
  };

  return (
    <section
      ref={sectionRef}
      id="priceform"
      className="rightforyou-section"
    >

      {/* TITLE */}
      <h2 className="right-title">
        Is Froth TestOps A Right Tool For Your Organization?
      </h2>

      {/* INFO TEXT */}
      <div className="info-containers">

        <div className="info-row">
          <img src={testops} alt="icon" />

          <p>
            You wish to automate repetitive tasks, streamline workflows,
            and reduce manual work that is taking your team members off
            other high-value activities.
          </p>
        </div>

        <div className="info-row" ref={sectionReftwo}>
          <img src={testops} alt="icon" />

          <p>
            You wish to have thorough test coverage, elaborate scenarios,
            and a strong reporting system so that the quality of your
            applications can be maintained at the highest level.
          </p>
        </div>

      </div>

      {/* BUTTON + FORM TOGGLE */}

{/* {!getTestOps ? (

  <div className="text-center">

    <button
      onClick={() => setLocalGetTestOps(true)}
      className="get-started-btn"
    >
      Get Started With TestOps
    </button>

  </div>

) : (

  <div className="form-wrapper">

    <div className="form-left">
      <img src={organization} alt="organization" />
    </div>

    <div className="form-right">
         <form>
    
            <div className="form-grid">

              <div className="relative">

                <label className="form-label">
                  Project Name*
                </label>

                <input
                  ref={projectNameRef}
                  type="text"
                  name="projectname"
                  placeholder="Project Name"
                  value={formData.projectname}
                  onChange={handleChange}
                  className="form-input"
                  autoComplete="off"
                />

                {formErrors.projectname && (
                  <p className="error-text">
                    {formErrors.projectname}
                  </p>
                )}

              </div>

              <div className="relative">

                <label className="form-label">
                  Project Short Code*
                </label>

                <input
                  ref={projectShortCodeRef}
                  type="text"
                  name="Projectshortcode"
                  placeholder="Project Short Code"
                  value={formData.Projectshortcode}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      Projectshortcode: e.target.value.toUpperCase(),
                    })
                  }
                  className="form-input"
                  autoComplete="off"
                  maxLength={5}
                />

                {formErrors.Projectshortcode && (
                  <p className="error-text">
                    {formErrors.Projectshortcode}
                  </p>
                )}

              </div>

              <div className="relative">

                <label className="form-label">
                  Project Status*
                </label>

                <select
                  ref={projectStatusRef}
                  name="projectStatus"
                  value={formData.projectStatus}
                  onChange={handleChange}
                  className="form-input"
                >
                  <option value="">Project Status</option>
                  <option value="Active">Active</option>
                  <option value="Completed">Completed</option>
                </select>

                {formErrors.projectStatus && (
                  <p className="error-text">
                    {formErrors.projectStatus}
                  </p>
                )}

              </div>

              <div className="relative">

                <label className="form-label">
                  Project Type*
                </label>

                <select
                  ref={projectTypeRef}
                  name="ProjectType"
                  value={formData.ProjectType}
                  onChange={handleChange}
                  className="form-input"
                >
                  <option value="">Project Type</option>
                  <option value="Web">Web</option>
                  <option value="Mobile">Mobile</option>
                </select>

                {formErrors.ProjectType && (
                  <p className="error-text">
                    {formErrors.ProjectType}
                  </p>
                )}

              </div>

              <div className="relative">

                <label className="form-label">
                  Project Start Date*
                </label>

                <div ref={startDateRef}>

                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select Start Date"
                    className="form-input"
                    wrapperClassName="date-wrapper"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    isClearable
                    autoComplete="off"
                  />

                  {formErrors.startDate && (
                    <p className="error-text">
                      {formErrors.startDate}
                    </p>
                  )}

                </div>

              </div>

              <div className="relative">

                <label className="form-label">
                  Project End Date*
                </label>

                <div ref={endDateRef}>

                  <DatePicker
                    selected={EndDate}
                    onChange={(date) => setEndDate(date)}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Select End Date"
                    className="form-input"
                    wrapperClassName="date-wrapper"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    isClearable
                    autoComplete="off"
                  />

                  {formErrors.EndDate && (
                    <p className="error-text">
                      {formErrors.EndDate}
                    </p>
                  )}

                </div>

              </div>

              <div className="relative">

                <label className="form-label">
                  Planned Effort (in hours)*
                </label>

                <input
                  ref={projectEffectRef}
                  type="text"
                  name="projectEffect"
                  placeholder="Planned Effort"
                  value={formData.projectEffect}
                  onChange={handleChange}
                  className="form-input"
                  autoComplete="off"
                />

                {formErrors.projectEffect && (
                  <p className="error-text">
                    {formErrors.projectEffect}
                  </p>
                )}

              </div>

              <div className="relative">

                <label className="form-label">
                  Team Size*
                </label>

                <input
                  ref={teamSizeRef}
                  type="text"
                  name="teamSize"
                  placeholder="Team Size"
                  value={formData.teamSize}
                  onChange={(e) => {

                    const value = e.target.value;

                    if (/^\d*$/.test(value)) {
                      setFormData({
                        ...formData,
                        teamSize: value,
                      });
                    }
                  }}
                  className="form-input"
                  autoComplete="off"
                />

                {formErrors.teamSize && (
                  <p className="error-text">
                    {formErrors.teamSize}
                  </p>
                )}

              </div>

            </div>

            <div className="description-group">

              <label className="form-label">
                Project Description*
              </label>

              <textarea
                ref={descriptionRef}
                name="Description"
                placeholder="Description"
                value={formData.Description}
                onChange={handleChange}
                className="form-textarea"
                autoComplete="off"
                rows={4}
                maxLength={500}
              />

              {formErrors.Description && (
                <p className="error-text">
                  {formErrors.Description}
                </p>
              )}

            </div>

            <div className="button-wrapper">

              <button
                type="button"
                onClick={ProjectForFree}
                className="submit-btn"
              >
                Create and Execute Project for FREE
              </button>

              </div>

          </form>

        </div>
      
    </div>

    )} */}

    </section>
  );
}

export default Rightforyou;